// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__044cI","brumer":"index_brumer__pfOah","desc":"index_desc__NjFBW"};